import { render, staticRenderFns } from "./UserFooter.vue?vue&type=template&id=577d916c&scoped=true&"
import script from "./UserFooter.vue?vue&type=script&lang=js&"
export * from "./UserFooter.vue?vue&type=script&lang=js&"
import style0 from "./UserFooter.vue?vue&type=style&index=0&id=577d916c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577d916c",
  null
  
)

export default component.exports